(function($) {
  const Member = function(options) {
    var defaults = {
      apiKey: null,
      cookieName: 'member',
      cookieValue: 'member',
      cookieValid: 7,
    }

    var settings = $.extend({}, defaults, options);

    return {
      isMember( name ) {
        var name = ( name !== undefined ) ? name : settings.cookieName;
        return Cookies.get(name) !== undefined;
      },

      getMember( name ) {
        var name = ( name !== undefined ) ? name : settings.cookieName;
        return Cookies.get(name);
      },

      setMember( name, value ) {
        var name = ( name !== undefined ) ? name : settings.cookieName;
        var value = ( value !== undefined ) ? value : settings.cookieValue;
        Cookies.set(name, value);
      },

      delMember( name ) {
        var name = ( name !== undefined ) ? name : settings.cookieName;
        Cookies.remove(name);
      },

      submit( data ) {
        var DATA = $.extend({}, {
          formKey: settings.apiKey,
          name: '',
          phone: '',
          email: '',
          countryCode: '',
          countryName: '',
          message: ''
        }, data);

        if (!DATA.formKey)
          return;

        var postcrs = $.post({
          url: 'https://hotelservices.travelanium.net/crs-customer-form-rs/restresources/CRSCustomerFormDataService',
          data: JSON.stringify(DATA),
          contentType: 'application/json'
        });

        postcrs.error(xhr => {
          console.log(xhr);
        });
      }
    }
  }

  if (undefined === window.Member) {
    window.Member = Member;
  }
})(jQuery);